<table *ngIf='showTable ; else errorTextField' mat-table [dataSource]="tableData" class="details-screen-table">
  <ng-container matColumnDef="objectMasterAssetTypeDescription">
    <th mat-header-cell *matHeaderCellDef> Type </th>
    <td mat-cell *matCellDef="let data"> {{data.objectMasterAssetTypeDescription ? data.objectMasterAssetTypeDescription : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="objectBrandDescription">
    <th mat-header-cell *matHeaderCellDef> Merk </th>
    <td mat-cell *matCellDef="let data"> {{data.objectBrandDescription ? data.objectBrandDescription : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="objectCategoryDescription">
    <th mat-header-cell *matHeaderCellDef> Object klasse </th>
    <td mat-cell *matCellDef="let data"> {{data.objectCategoryDescription ? data.objectCategoryDescription : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="objectSubcategoryDescription">
    <th mat-header-cell *matHeaderCellDef> Object subklasse </th>
    <td mat-cell *matCellDef="let data"> {{data.objectSubcategoryDescription ? data.objectSubcategoryDescription : emptyValuePlaceholder}} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
</table>
<ng-template #errorTextField>
  <div class="error-text">
  {{errorText}}
  </div>
</ng-template>
